import { useIsDealershipPage } from '~/context/dealership/StaticContext';
import { useIsCampaignTemplateOne } from '~/context/vdp/StaticContext';
import useTrackRendered from '~/hooks/common/telemetry/useTrackRendered';
import useScrollPosition from '~/hooks/vdp/cta/useScrollPosition';
import useIsNotAvailableForImmediatePurchase from '~/hooks/vdp/selectors/useIsNotAvailableForImmediatePurchase';
import useHasMappedWhyBuyFeatures from '~/hooks/vdp/useHasMappedWhyBuyFeatures';
import useShowWhyBuyContent from '~/hooks/vdp/useShowWhyBuyContent';

const EXPERIMENT = 'car-merch-ui-vdp-why-buy-imagery';
const SCROLL_DEPTH = 700;
const NOT_AVAILABLE_SCROLL_DEPTH = 1400;

export default function useTrackWhyBuyImageryRendered(): void {
  const hasMappedFeatures = useHasMappedWhyBuyFeatures();
  const isCampaignTemplateOne = useIsCampaignTemplateOne();
  const isDealershipPage = useIsDealershipPage();
  const isNotAvailableForImmediatePurchase =
    useIsNotAvailableForImmediatePurchase();
  const scrollPosition = useScrollPosition();
  const showWhyBuyContent = useShowWhyBuyContent();

  const isWhyBuyImageryRendered =
    showWhyBuyContent &&
    hasMappedFeatures &&
    !isCampaignTemplateOne &&
    !isDealershipPage;
  const scrollDepth = isNotAvailableForImmediatePurchase
    ? NOT_AVAILABLE_SCROLL_DEPTH
    : SCROLL_DEPTH;

  useTrackRendered(
    EXPERIMENT,
    isWhyBuyImageryRendered && scrollPosition >= scrollDepth
  );
}
